import React,{useState} from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import premiumRoom from '../../../images/hotel2.jpg';
import { BsPerson } from "react-icons/bs";
import { IoMdPerson } from "react-icons/io";
import { HashLink as Link } from 'react-router-hash-link';

import './AvailabilitiesCards.css';
import CondCard from './CondCard';
import FeatureCard from './FeatureCard';
import ThirdCard from './ThirdCard';

function AvailabilitiesCards() {
    const [activated,setActive]= useState('FirstCard');
    // const [isFocus,setFocus]= useState('false');

    function handlePress(){
         setActive('FirstCard');
        //  setFocus(!isFocus);
    }
    
    function handlePress2(){
         setActive('SecondCard');
        //  setFocus(!isFocus);
    }
    function handlePress3(){
         setActive('ThirdCard');
        //  setFocus(!isFocus);
    }


    return (
        <div>
            <Container id='firstCard'  className='card-container'>
                <div className='deluxH3Wrapper'>
                    <h3 className='deluxH3'>Delux Room(1 Adult, 0 Children)</h3>
                </div>
                <div className='roomSpec'>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12} className='ColContent'>
                            <Row>
                            <Col lg={3} className='roomImgWrapper'>
                                <img src={premiumRoom} alt='tof' className='deluxTof' />
                            
                            </Col>
                            <Col lg={9} className='roomContentWrapper'>
                                <Row>
                                <Col xl={6} lg={6}  className='div1'>
                                    <h3>Delux </h3>
                                    <div className='pos'>
                                        <div className='iconBox'>
                                            <IoMdPerson className='svg' size='23px' />
                                            <BsPerson className='svg' size='23px' />
                                            <BsPerson className='svg' size='23px' />
                                            <BsPerson className='svg' size='' />
                                        </div>
                                        <p>Room Size : 349 sq. ft.</p>
                                    </div>
                                </Col>
                                <Col xl={6} lg={6} className='div2'>
                                    <p className='prix'>From <span className='number'>2400</span> INR/night</p>
                                </Col>
                                </Row>
                            </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/* <Row className='navigationBox'>
                        <Col xl={2} lg={2} md={2} sm={4} className='colRates'>
                            <Button type='button' className='Rates'>Rates</Button>
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={4} className='colAmenities'>
                            <Button type='button' className='Amenities'>Amenities</Button>
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={4} className='colPhotos'>
                            <Button type='button' className='Photos' >Photos</Button>
                        </Col>
                    </Row> */}
                </div>
                <Row className='navigationBox'>
                        <Col xl={2} lg={2} md={2} sm={4} xs={4} className='colRates'>
                            <Button type='button' autoFocus    className=' Rates'  onClick={handlePress }   >Rates</Button>
                            
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={4} xs={4} className='colAmenities'>
                            <Button type='button'   className='Amenities'   onClick={handlePress2} >Amenities</Button>
                            
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={4} xs={4} className='colPhotos'>
                            <Button type='button'   className='Photos'  onClick={handlePress3} >Photos</Button>
                            
                        </Col>
                    </Row>
                    <Row>
                        <div id='FirstCard'>
                             {activated==='FirstCard'&&<CondCard    />}
                        </div>
                        <div>
                             {activated==='SecondCard'&&<FeatureCard  config={setActive} />}
                        </div>
                        <div>
                            {activated==='ThirdCard'&&<ThirdCard  config={setActive} />}
                        </div>
                        
                        
                    </Row>
            
            </Container>
        </div>
    )
}

export default AvailabilitiesCards
